import { render, staticRenderFns } from "./TabMedien.vue?vue&type=template&id=492fe22a&scoped=true"
import script from "./TabMedien.vue?vue&type=script&lang=js"
export * from "./TabMedien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fe22a",
  null
  
)

export default component.exports